// @flow

import NestedResource from 'speed-js-core/src/api/NestedResource';

export default class CoverageGEOResource extends NestedResource {
    basePath: string = 'addresses/maps/{parent}/coverage/geo/';

    objectPath: string = 'addresses/maps/{parent}/coverage/geo/{ident}/';

    getVersions(mapUuid: string, identity: string): Promise<Object> {
        // $FlowFixMe
        return this.client._request(`${this._getBasePath(mapUuid)}versions/${identity}`,
            'GET').then((response) => response.data);
    }

    changeForAddress(parentId: string, addressId: string, coverageType: string): Promise<Object> {
        // $FlowFixMe
        return this.client._request(`${this._getBasePath(parentId)}address/`, 'POST', {
            address: addressId, coverage_type: coverageType,
        }).then((response) => response.data);
    }

    deleteCoverage(parentId: string, addressId: string): Promise<Object> {
        // $FlowFixMe
        return this.client._request(`${this._getBasePath(parentId)}address/`, 'DELETE', {
            address: addressId,
        }).then((response) => response.data);
    }
}
